import React from "react";
import "./hero.css";
import { useHistory } from "react-router-dom";

const Hero: React.FC = () => {
  const history = useHistory();
  return (
    <section className="hero">
      <div className="glow" aria-hidden="true"></div>
      <div className="container" style={{ maxWidth: 900 }}>
        <h1>Profit from market moves — fast & simple</h1>
        <p>
          Open a demo in 10 seconds and test your strategy risk-free. Modern
          interface, instant orders, transparent terms.
        </p>
        <div className="cta">
          <button className="btn" onClick={() => history.push("/login")}>
            Sign In
          </button>
          <button
            className="btn secondary"
            onClick={() => history.push("/register")}
          >
            Sign Up
          </button>
        </div>
        <div className="badges">
          <div className="badge">⚡ Instant execution</div>
          <div className="badge">💳 Fast withdrawals</div>
          <div className="badge">🛡️ Data protection</div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
